import React from 'react';
import { Gift, Coins, DollarSign, Building2 } from 'lucide-react';
import { Budget, QuestionnaireData } from '../../types';

interface BudgetStepProps {
  data: Partial<QuestionnaireData>;
  onChange: (data: Partial<QuestionnaireData>) => void;
}

const budgetOptions = [
  {
    id: 'free' as Budget,
    label: 'Free / $0',
    description: 'Free tools only',
    Icon: Gift
  },
  {
    id: 'low' as Budget,
    label: 'Under $50/month',
    description: 'Budget-friendly options',
    Icon: Coins
  },
  {
    id: 'medium' as Budget,
    label: '$50 - $200/month',
    description: 'Professional tools',
    Icon: DollarSign
  },
  {
    id: 'high' as Budget,
    label: 'Over $200/month',
    description: 'Enterprise solutions',
    Icon: Building2
  },
];

export function BudgetStep({ data, onChange }: BudgetStepProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
      {budgetOptions.map((option) => {
        const Icon = option.Icon;
        return (
          <button
            key={option.id}
            onClick={() => onChange({ budget: option.id })}
            className={`p-4 sm:p-6 rounded-xl border-2 transition-all text-left ${
              data.budget === option.id
                ? 'border-blue-600 bg-blue-50'
                : 'border-gray-200 hover:border-blue-200 hover:bg-gray-50'
            }`}
          >
            <Icon className={`w-6 h-6 sm:w-8 sm:h-8 mb-3 sm:mb-4 ${
              data.budget === option.id ? 'text-blue-600' : 'text-gray-600'
            }`} />
            <h3 className="text-base sm:text-lg font-semibold mb-1 sm:mb-2">{option.label}</h3>
            <p className="text-sm sm:text-base text-gray-600">{option.description}</p>
          </button>
        );
      })}
    </div>
  );
}

export default BudgetStep;